export const getUnpinnedEvents = (uniqueEvents) => {
    return uniqueEvents.filter((event) => !event.pinned);
};
const getZeroVolumeEvents = (eventsPopularity) => {
    return eventsPopularity.filter((event) => event.all_name_counts === 0);
};
const getZeroVolumeEventLabels = (zeroVolumeEvents) => {
    const labels = [];
    zeroVolumeEvents.forEach((event) => {
        const label = (event.name || '').toLowerCase().replace(/_/g, ' ');
        labels.push(label);
    });
    return labels;
};
export const getUnpinnedEventsWithZeroVolume = (unpinnedEvents, zeroVolumeEventLabels) => {
    return unpinnedEvents.filter((event) => {
        const label = event.label.toLowerCase();
        return zeroVolumeEventLabels.some((zeroEventLabel) => label.includes(zeroEventLabel));
    });
};
export const getUnpinnedEventsWithoutZeroVolume = (unpinnedEvents, unpinnedEventsWithZeroVolume) => {
    return unpinnedEvents.filter((event) => {
        if (!unpinnedEventsWithZeroVolume.includes(event)) {
            return event;
        }
    });
};
export const reorderZeroVolumeUnpinnedEvents = (uniqueEvents, eventsPopularity) => {
    const unpinnedEvents = getUnpinnedEvents(uniqueEvents);
    const zeroVolumeEvents = getZeroVolumeEvents(eventsPopularity);
    const zeroVolumeEventLabels = getZeroVolumeEventLabels(zeroVolumeEvents);
    const unpinnedEventsWithZeroVolume = getUnpinnedEventsWithZeroVolume(unpinnedEvents, zeroVolumeEventLabels);
    const unpinnedEventsWithoutZeroVolume = getUnpinnedEventsWithoutZeroVolume(unpinnedEvents, unpinnedEventsWithZeroVolume);
    return [...unpinnedEventsWithoutZeroVolume, ...unpinnedEventsWithZeroVolume];
};
export const sortEventsByPopularity = (events, eventsPopularity) => {
    const eventIdentifiers = [];
    eventsPopularity.forEach((event) => {
        const label = (event.name || '').toLowerCase();
        eventIdentifiers.push(label);
    });
    const sortedEvents = [];
    eventIdentifiers.forEach((identifier) => {
        events.forEach((event) => {
            if (event.label.includes(identifier)) {
                sortedEvents.push(event);
            }
        });
    });
    events.forEach((event) => {
        sortedEvents.push(event);
    });
    const uniqueSortedEvents = sortedEvents.filter((element, position) => {
        return sortedEvents.indexOf(element) === position;
    });
    const pinnedSortedEvents = uniqueSortedEvents.filter((event) => event.pinned);
    const unpinnedSortedEvents = reorderZeroVolumeUnpinnedEvents(uniqueSortedEvents, eventsPopularity);
    return [...pinnedSortedEvents, ...unpinnedSortedEvents];
};
//# sourceMappingURL=index.js.map